import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import DateFormat from '../common/dateFormat/DateFormat';
import ReactExport from 'react-export-excel-fixed-xlsx';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import SelectResumido from '../common/form/selectResumido';

import {
	getLista,
	alterarMotoristaGrupo,
	alterarMotoristaGrupoMassa
} from './motoristaActions';

import {
	getLista as getListaMotoristaGrupo
} from '../motoristaGrupo/motoristaGrupoActions';


class MotoristaGrupo extends Component {

	state = {
		linhaSelecionada: null,

		pesquisar: '',
		id_motorista_grupo: null,

		modoMassa: false,
		motoristasSelecionados: [],
		id_motorista_grupo_massa: null,

		ordenacao: {
			nome: 1
		}
	}


	componentWillMount() {

		this.props.getLista();
		this.props.getListaMotoristaGrupo();
	}


	render() {

		return (
			<div>
				<Content>

					<Aguardando
						aguardando={this.props.aguardando}
					/>

					{this.lista()}

				</Content>
			</div>
		);
	}


	getNovaOrdenacao(atual) {

		return atual == 2
			? 0
			: (atual || 0) + 1;
	}


	getIconeOrdenacao(tipo) {

		if (tipo == 1) {

			return (
				<i className='fas fa-sort-amount-down-alt' />
			);

		} else if (tipo == 2) {

			return (
				<i className='fas fa-sort-amount-up' />
			);

		}

		return null;
	}


	alternarModoMassa = () => {

		this.setState({
			modoMassa:
				!this.state.modoMassa,

			motoristasSelecionados:
				[],

			id_motorista_grupo_massa:
				null
		});
	}


	selecionarTodos = (lista, checked) => {

		if (checked) {

			this.setState({
				motoristasSelecionados:
					lista.map(item => item.id)
			});

		} else {

			this.setState({
				motoristasSelecionados: []
			});
		}
	}


	selecionarMotorista = (id, checked) => {

		let selecionados = [
			...(this.state.motoristasSelecionados || [])
		];

		if (checked) {

			if (!selecionados.includes(id)) {
				selecionados.push(id);
			}

		} else {

			selecionados =
				selecionados.filter(
					item => item != id
				);
		}

		this.setState({
			motoristasSelecionados:
				selecionados
		});
	}


	aplicarGrupoMassa = () => {

		const selecionados =
			this.state.motoristasSelecionados || [];

		const idGrupo =
			this.state.id_motorista_grupo_massa;

		if (!idGrupo || !selecionados.length) {
			return;
		}

		this.props.alterarMotoristaGrupoMassa(
			selecionados.map(idMotorista => {

				const motorista =
					this.props.lista.find(
						item =>
							item.id == idMotorista
					);

				if (!motorista) {
					return;
				}

				return {
					...motorista,
					id_motorista_grupo: idGrupo
				};
			})
		);

		this.setState({
			modoMassa: false,
			motoristasSelecionados: [],
			id_motorista_grupo_massa: null
		});
	}


	lista() {

		const ExcelFile =
			ReactExport.ExcelFile;

		const ExcelSheet =
			ReactExport.ExcelFile.ExcelSheet;

		const ExcelColumn =
			ReactExport.ExcelFile.ExcelColumn;


		let lista = this.props.lista.filter(item => {

			if (item.data_desligamento) {
				return false;
			}

			if (
				this.state.id_motorista_grupo &&
				item.id_motorista_grupo !=
					this.state.id_motorista_grupo
			) {
				return false;
			}

			return !(this.state.pesquisar || '').trim()
				||
				(this.state.pesquisar.toUpperCase() || '')
					.split('+')
					.filter(pesquisar =>
						(pesquisar || '').trim()
					)
					.filter(pesquisar => {

						if (
							pesquisar &&
							!(`
								${item.nome}
								${DateFormat.formatarDataSqlParaTela(item.data_admissao)}
								${item.tempo_contrato}
								${item.nome_motorista_grupo}
							`)
								.toUpperCase()
								.includes(pesquisar)
						) {
							return false;
						}

						return true;

					}).length > 0;
		});


		if (this.state.ordenacao.nome) {

			lista.sort((a, b) =>
				this.state.ordenacao.nome == 1
					? (
						a.nome > b.nome
							? 1
							: -1
					)
					: (
						a.nome > b.nome
							? -1
							: 1
					)
			);

		} else if (
			this.state.ordenacao.data_admissao
		) {

			lista.sort((a, b) =>
				this.state.ordenacao.data_admissao == 1
					? (
						a.data_admissao > b.data_admissao
							? 1
							: -1
					)
					: (
						a.data_admissao > b.data_admissao
							? -1
							: 1
					)
			);

		} else if (
			this.state.ordenacao.tempo_contrato
		) {

			lista.sort((a, b) =>
				this.state.ordenacao.tempo_contrato == 1
					? (
						a.data_admissao > b.data_admissao
							? 1
							: -1
					)
					: (
						a.data_admissao > b.data_admissao
							? -1
							: 1
					)
			);

		} else if (
			this.state.ordenacao.nome_motorista_grupo
		) {

			lista.sort((a, b) =>
				this.state.ordenacao.nome_motorista_grupo == 1
					? (
						(a.nome_motorista_grupo || '') >
						(b.nome_motorista_grupo || '')
							? 1
							: -1
					)
					: (
						(a.nome_motorista_grupo || '') >
						(b.nome_motorista_grupo || '')
							? -1
							: 1
					)
			);
		}


		const todosSelecionados =
			lista.length > 0 &&
			lista.every(item =>
				(this.state.motoristasSelecionados || [])
					.includes(item.id)
			);


		return (
			<ContentCard>

				<ContentCardBody>

					<Row>

						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.state.pesquisar}
							onChange={value =>
								this.setState({
									pesquisar: value
								})
							}
						/>

						<Select
							options={
								this.props.listaMotoristaGrupo
							}
							label='Grupo de Motorista'
							maxWidth={300}
							minWidth={300}
							cols='12 12 4 4'
							placeholder='Selecione'
							value={
								this.state.id_motorista_grupo
							}
							onChange={value => {

								this.setState({
									id_motorista_grupo:
										value
								});
							}}
						/>


						<div
							style={{
								width: 280,
								marginTop: 8,
								marginLeft: 8
							}}
						>

							<a
								className='btn btn-app bg-primary'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {

									this.props.getLista();

									this.props
										.getListaMotoristaGrupo();
								}}
							>
								<i className='fas fa-sync-alt'></i>
								{' '}
								Atualizar
							</a>


							<a
								className={
									this.state.modoMassa
										? 'btn btn-app bg-danger'
										: 'btn btn-app bg-primary'
								}
								style={{
									marginLeft: 2,
									minWidth: 100
								}}
								onClick={() =>
									this.alternarModoMassa()
								}
							>
								<i
									className={
										this.state.modoMassa
											? 'fas fa-times'
											: 'fas fa-users'
									}
								></i>

								{' '}

								{this.state.modoMassa
									? 'Cancelar'
									: 'Em Massa'
								}
							</a>


							<ExcelFile
								filename={'Motoristas'}
								element={
									<a
										className='btn btn-app bg-success'
										style={{
											marginLeft: 2,
											minWidth: 75
										}}
									>
										<i className='fas fa-file-excel'></i>
										{' '}
										Exportar
									</a>
								}
							>
								<ExcelSheet
									data={
										lista.map(item => ({
											...item
										}))
									}
									name='Motoristas'
								>
									<ExcelColumn
										label='Nome'
										value='nome'
									/>

									<ExcelColumn
										label='Grupo'
										value='nome_motorista_grupo'
									/>

								</ExcelSheet>
							</ExcelFile>

						</div>
					
					{this.state.modoMassa &&

							<div
								style={{
									display: 'flex',
									alignItems: 'flex-end',
									gap: 10,
									padding: '10px 15px',
									marginBottom: 10,
									backgroundColor: '#eef2f7',
									border: '1px solid #d7dee8',
									borderRadius: 6
								}}
							>

								<Select
									options={
										this.props.listaMotoristaGrupo
									}
									label='Grupo para aplicar'
									maxWidth={300}
									minWidth={300}
									cols='12 12 4 4'
									placeholder='Selecione'
									value={
										this.state
											.id_motorista_grupo_massa
									}
									onChange={value => {

										this.setState({
											id_motorista_grupo_massa:
												value
										});
									}}
								/>


								<button
									type='button'
									className='btn btn-success'
									style={{
										height: 38,
										marginBottom: 16
									}}
									disabled={
										!this.state
											.id_motorista_grupo_massa
										||
										!(
											this.state
												.motoristasSelecionados
											|| []
										).length
									}
									onClick={() =>
										this.aplicarGrupoMassa()
									}
								>
									<i className='fas fa-check'></i>
									{' '}
									Aplicar

									{(
										this.state
											.motoristasSelecionados
										|| []
									).length > 0
										? ` (${this.state.motoristasSelecionados.length})`
										: ''
									}
								</button>
							</div>
					}

					</Row>


					<div
						style={{
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,

							height:
								window.innerWidth < 768
									? '100%'
									: (
										window.innerWidth < 1093
											? `${window.innerHeight - 300}px`
											: (
												window.innerWidth < 1799
													? `${window.innerHeight - 180}px`
													: (
														window.innerWidth < 4000
															? `${window.innerHeight - 180}px`
															: `${window.innerHeight - 110}px`
													)
											)
									)
						}}
					>

						<Table
							responsive
							border
							striped
							alturaFixa
							maxHeight={
								window.innerWidth < 768
									? '100%'
									: (
										window.innerWidth < 1093
											? `${window.innerHeight - 300}px`
											: (
												window.innerWidth < 1799
													? `${window.innerHeight - 180}px`
													: (
														window.innerWidth < 4000
															? `${window.innerHeight - 180}px`
															: `${window.innerHeight - 110}px`
													)
											)
									)
							}
						>

							<THead>

								<Tr
									backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}
								>

									{this.state.modoMassa &&
										<Th
											paddingTop={2}
											paddingBottom={2}
											width={50}
											sticky
											backgroundColor={'#1F3066'}
											color={'#ffffff'}
											alignCenter
										>
											<input
												type='checkbox'
												style={{
													transform: 'scale(2)',
													cursor: 'pointer'
												}}
												checked={
													todosSelecionados
												}
												onChange={event => {

													this.selecionarTodos(
														lista,
														event.target.checked
													);
												}}
											/>
										</Th>
									}


									<Th
										paddingTop={2}
										paddingBottom={2}
										width={300}
										onClick={() =>
											this.setState({
												...this.state,

												ordenacao: {
													nome:
														this.getNovaOrdenacao(
															this.state
																.ordenacao
																.nome
														)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignLeft
									>
										Nome
										{' '}
										{this.getIconeOrdenacao(
											this.state.ordenacao.nome
										)}
									</Th>


									<Th
										paddingTop={2}
										paddingBottom={2}
										width={100}
										onClick={() =>
											this.setState({
												...this.state,

												ordenacao: {
													data_admissao:
														this.getNovaOrdenacao(
															this.state
																.ordenacao
																.data_admissao
														)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Data de Admissão
										{' '}
										{this.getIconeOrdenacao(
											this.state
												.ordenacao
												.data_admissao
										)}
									</Th>


									<Th
										paddingTop={2}
										paddingBottom={2}
										width={200}
										onClick={() =>
											this.setState({
												...this.state,

												ordenacao: {
													tempo_contrato:
														this.getNovaOrdenacao(
															this.state
																.ordenacao
																.tempo_contrato
														)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Tempo de Empresa
										{' '}
										{this.getIconeOrdenacao(
											this.state
												.ordenacao
												.tempo_contrato
										)}
									</Th>


									<Th
										paddingTop={2}
										paddingBottom={2}
										width={200}
										onClick={() =>
											this.setState({
												...this.state,

												ordenacao: {
													nome_motorista_grupo:
														this.getNovaOrdenacao(
															this.state
																.ordenacao
																.nome_motorista_grupo
														)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Grupo de Motorista
										{' '}
										{this.getIconeOrdenacao(
											this.state
												.ordenacao
												.nome_motorista_grupo
										)}
									</Th>

								</Tr>

							</THead>


							<TBody>

								{lista.map((item, i) => (

									<Tr
										key={item.id}

										backgroundColor={
											this.state.linhaSelecionada ==
												item.id
												? '#bcc7eb'
												: (
													i % 2 == 0
														? '#ffffff'
														: '#f5f5f5'
												)
										}

										onClick={() =>
											this.setState({
												...this.state,

												linhaSelecionada:
													item.id
											})
										}
									>

										{this.state.modoMassa &&
											<Td
												color={'#000'}
												alignCenter
												small
											>
												<input
													type='checkbox'
													style={{
														transform: 'scale(2)',
														cursor: 'pointer'
													}}
													checked={
														(
															this.state
																.motoristasSelecionados
															|| []
														).includes(item.id)
													}

													onClick={event => {
														event.stopPropagation();
													}}

													onChange={event => {

														this.selecionarMotorista(
															item.id,
															event.target.checked
														);
													}}
												/>
											</Td>
										}


										<Td
											color={'#000'}
											alignLeft
											small
										>
											{item.nome}
										</Td>


										<Td
											color={'#000'}
											alignCenter
											small
										>
											{DateFormat
												.formatarDataSqlParaTela(
													item.data_admissao
												)}
										</Td>


										<Td
											color={'#000'}
											alignCenter
											small
										>
											{item.tempo_contrato}
										</Td>


										<Td
											color={'#000'}
											alignCenter
											small
										>

											<SelectResumido
												options={
													this.props
														.listaMotoristaGrupo
												}
												placeholder='Selecione'
												value={
													item.id_motorista_grupo
												}

												onChange={value => {

													this.props
														.alterarMotoristaGrupo({
															...item,

															id_motorista_grupo:
																value
														});
												}}
											/>

										</Td>

									</Tr>
								))}

							</TBody>

						</Table>

					</div>

				</ContentCardBody>

			</ContentCard>
		);
	}
}


const mapStateToProps = state => ({

	sessao:
		state.auth.usuario,

	usuarioCarregado:
		state.auth.usuarioCarregado,

	aguardando:
		state.motorista.aguardando,

	lista:
		state.motorista.lista,

	listaMotoristaGrupo:
		state.motoristaGrupo.listaSelect
});


const mapDispatchToProps = dispatch =>
	bindActionCreators({

		getLista,
		alterarMotoristaGrupo,
		alterarMotoristaGrupoMassa,
		getListaMotoristaGrupo

	}, dispatch);


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MotoristaGrupo);